<template>
    <div class="setting-content--section">
        <b-form  @submit="onSubmit">
            <b-form-group id="input-group-1" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Logo')" label-for="input-1">
                <VueDropzone :preloaded_file="imageSrc" :allowed-files="'all'" :onlyChange="true" @change="fileChanged"></VueDropzone>
            </b-form-group>
            <b-form-group id="input-group-1" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Name') + '*'" label-for="input-1" :description="$gettext('Name of your company.')">
                <b-form-input id="input-1" v-model="form.name" required :placeholder="$gettext('Enter company name')" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-2" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Type of business entity')" label-for="input-2">
                <b-form-select id="input-2" v-model="form.legal_form" :options="entities" value-field="key" text-field="value" @change="onFormChange"></b-form-select>
            </b-form-group>
            <b-form-group id="input-group-3" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Sector') + '*'" label-for="input-3">
                <b-form-select id="input-3" v-model="form.sector" :options="sectors" required value-field="key" text-field="value" @change="onFormChange">
                    <template #first>
                        <b-form-select-option :value="null" >---------</b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group id="input-group-4" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Company Description')" label-for="input-4">
                <b-form-textarea id="input-4" v-model="form.description" :placeholder="$gettext('Enter a description here...')" rows="3" @change="onFormChange"></b-form-textarea>
            </b-form-group>
            <b-form-group id="input-group-5" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Address')" label-for="input-5">
                <b-form-input id="input-5" v-model="form.address" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-6" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Postal Code')" label-for="input-6">
                <b-form-input id="input-6" v-model="form.postal_code" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-7" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('City')" label-for="input-7">
                <b-form-input id="input-7" v-model="form.city" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-8" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Country') + '*'" label-for="input-8">
                <b-form-select id="input-8" v-model="form.country" :options="countries" @change="onFormChange" required></b-form-select>
            </b-form-group>
            <b-form-group id="input-group-9" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Phone number')" label-for="input-9">
                <b-form-input id="input-9" v-model="form.phone_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-10" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-10" class="checkbox-bg-color" v-model="form.phone_number_show_on_invoice" @change="onFormChange" switch><span v-translate>Show phone number on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-11" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Email')" label-for="input-11" :description="$gettext('Invoices will be sent from this e-mail address.')">
                <b-form-input id="input-11" v-model="form.email" type="email" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-13" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('VAT identification number')" label-for="input-13">
                <b-form-input id="input-13" v-model="form.btw" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-14" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-14" class="checkbox-bg-color" v-model="form.btw_show_on_invoice" @change="onFormChange" switch><span v-translate>Show VAT identification number on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-15" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Bank name')" label-for="input-15">
                <b-form-input id="input-15" v-model="form.bank_name" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-16" label-cols-sm="3" label-align-sm="right" content-cols-md="5"  label-class="gk-label-margin" :label="$gettext('Bank account number')" label-for="input-16">
                <b-form-input id="input-16" v-model="form.bank_account_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-19" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" label="" label-for="input-19">
                <GekkoButton 
                    :text="$gettext('Create')" 
                    type="submit"
                />
            </b-form-group>

        </b-form>
    </div>
</template>

<script>
// @ is an alias to /src
import CompanyService from "@/store/services/company.service.js";
import VueDropzone from "@/components/VueDropzone";
import GekkoButton from "@/components/GekkoButton";

// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "CreateCompany",
    components: {
        VueDropzone, GekkoButton
    },
    mixins: [settingsPageSetup],
    data() {
        return {
            pageSettings: {
                title: this.$gettext("Create a company"),
                showCompanyPicker: false
            },
            formChanged: false,
            form: {
                address: '',
                bank_account_number: '',
                bank_name: '',
                btw: '',
                btw_show_on_invoice: false,
                city: '',
                country: 'NL',
                description: '',
                email: '',
                kvk: '',
                legal_form: '',
                logo: null,
                name: '',
                phone_number: '',
                phone_number_show_on_invoice: false,
                postal_code: '',
                sector: ''
            },
            entities: [],
            sectors: [],
            countries: [],
            imageSrc: '',
        }
    },
    created(){
        var vm = this;
        CompanyService.getBusinessEntities().then(function(response){
            vm.entities = response.data[vm.form.country.toLowerCase()];
        });
        CompanyService.getSectors().then(function(response){
            vm.sectors = response.data;
        });
        CompanyService.getCountries().then(function(response){
            vm.countries = response.data;
        });
    },
    methods: {
        onSubmit(e) {
            e.preventDefault();
            let vm = this;
            CompanyService.create(vm.form).then(function(response) {
                vm.redirect(response.data.id);
            }).catch((error) => {
                if (error.status === 403) {
                    this.$store.commit('togglePremiumModal', 'web_companies');
                }
            });
        },
        redirect(target_company){
            let vm = this;
            var url = window.Urls['accounts_switch_profile_company'](target_company);
            window.location.href = url;
        },
        fileChanged(file){
            this.cost.image = file;
        },
        onFormChange(){
            this.formChanged = true;
        }
    },
    beforeRouteLeave (to, from , next) {
      var answer = true;
      if(this.formChanged){
        answer = window.confirm(this.$gettext('You made changes that have not yet been saved. Are you sure you want to continue and discard those changes?'))
      }
      if (answer) {
        next()
      } else {
        next(false)
      }
    }
};
</script>
<style >
.checkbox-bg-color .custom-control-input:checked ~ .custom-control-label::before{
    border-color: #0575ff;
    background-color: #0575ff;
}

.float-alert-top{
    position: fixed !important;
    top: 50px;
    right: 15%;
    z-index: 1000;
}
</style>
